export default {
  prefix: "fapzse",
  iconName: "post-install",
  icon: [24, 24, [], "asfcbc107", ""]
};
